export const headerName = {
  edit: "Редактирование программы подготовки судоводителей",
};
export const preparationProgramData = {
  sctName: {
    key: "name",
    label: "Полное наименование программы",
    type: "text",
    required: true,
  },
  sctNote: {
    key: "sign",
    label: "Краткое наименование программы",
    type: "text",
    required: true,
  },
};

export const getPreparationProgramDataModal = () => preparationProgramData;
